import { DoraGradeThresholds } from "../getDoraGrade";

export const CHART_TYPE_STORAGE_KEY = "time-to-recovery";

// Quartile thresholds in seconds (upper bound of each tier)
export const TIME_TO_RECOVERY_THRESHOLDS: DoraGradeThresholds = {
  excellentMax: 65_739,
  fairMax: 146_436,
};
